<template>
  <ItemRow>
    <ItemWithLabel
      class="column"
      :column="columns[0]"
    >
      <span class="iconWrapper">
        <Icon
          :icon="deviceIcon"
          :scale="1.5"
        />
      </span>
      <span
        :data-test-id="$testId('deviceNameSpan')"
      >
        {{ deviceName }}
      </span>
    </ItemWithLabel>
    <ItemWithLabel
      class="column"
      :column="columns[1]"
    >
      {{ itemData.appVersion }}
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import {
  Icon,
  ItemRow,
  ItemWithLabel,
} from '@jumpcloud/ui-components';
import { passwordManagerOSLabels } from 'client/PasswordManager/PasswordManagerConstants';

export default {
  name: 'PwmUserAppsItemListRow',

  components: {
    Icon,
    ItemRow,
    ItemWithLabel,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },

    itemData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    deviceIcon() {
      return passwordManagerOSLabels.find(item => item.os === this.itemData.osId).icon;
    },

    deviceName() {
      return passwordManagerOSLabels.find(item => item.os === this.itemData.osId).label;
    },
  },
};
</script>

<style scoped>
.iconWrapper {
  align-items: center;
  background: var(--jc-color-disabled-stroke);
  border-radius: 100%;
  color: var(--icon-color, var(--jc-text-color));
  display: inline-flex;
  height: 2em;
  justify-content: center;
  line-height: 1;
  margin-right: var(--jc-spacer-x-small);
  width: 2em;
}

.column {
  align-items: center;
  display: flex;
}
</style>
